import jwtDecode from "jwt-decode";
export class Token {
    #type;
    #original;
    constructor(type, value) {
        this.#type = type;
        this.#original = value;
    }
    get encoded() {
        return this.#original;
    }
    get decoded() {
        return jwtDecode(this.encoded);
    }
    get expiration() {
        const timestamp = this.decoded.exp * 1000;
        return {
            timestamp,
            date: new Date(timestamp),
        };
    }
    get isExpired() {
        return this.expiration.timestamp <= Date.now();
    }
}
